// extracted by mini-css-extract-plugin
export default {"modal":"LoadingModal_modal__UAE5H","Loader":"LoadingModal_Loader__b4exW"};